var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultLayout',{staticClass:"FeedView"},[_c('h1',{staticClass:"mb-4 display-1"},[_vm._v(" Лента событий ")]),_c('VSkeletonLoader',{attrs:{"loading":_vm.loading && !_vm.posts,"type":"article@5"}},[_c('Posts')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }